import { IConfigsType } from '../../types'

const fwSmartKitchen: IConfigsType = {
  'fw_wingstop-customized-reports-7375b6fb': {
    '/:brand/smart_kitchen': {
      disableAutoMargin: true,
      feV2: {
        type: 'FE V2',
        configPath: 'fw_wingstop/smart_kitchen',
        height: '100vh',
      },
    },
  },
}

export default fwSmartKitchen
